<template>
  <div class="page">
    <div class="content">
      <div class="title">Publications for platform development:</div>
      <div v-for="(item, index) in platformDevelopmentPublications" :key="index">
        <a :href="item.link"  target="_blank" class="link">
         <div>({{ item.order }}) {{ item.description }}</div>
        </a>
      </div>
      <div class="title">Publications for using ExposomeX platform:</div>
      <div v-for="(item, index) in ExposomeXPlatformPublications" :key="index">
        <a v-if="item.link" :href="item.link"  target="_blank" class="link">
          <div>({{ item.order }}) {{ item.description }}</div>
        </a>
        <div v-if="!item.link">({{ item.order }}) {{ item.description }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      platformDevelopmentPublications: [{
        order: 1,
        link: 'https://pubs.acs.org/doi/10.1021/acs.est.5c05956',
        description: 'Bin Wang, Changxin Lan, Guohuan Zhang, Mengyuan Ren, Tianxiang Wu, Ning Gao, Weinan Lin, Yanqiu Feng, Han Zhang, Bahabake Jiangtulu, Yuting Wang, Shu Su, Zhijian Liu, Xuqiang Shao, Fanrong Zhao, Bo Peng, Xiaotong Ji, Xiaojia Chen, Min Nian, Junjie Yang, and Mingliang Fang*. ExposomeX: Development of an Integrative Exposomic Platform to Expedite Discovery of the "Exposure-Biology-Disease" Nexus. Environ Sci Technol. 2025 Jul 8;59(26):13251-13263.'
      }, {
        order: 2,
        link: 'http://www.the-innovation.org/issue/20211128/S2666-6758(21)00097-7/',
        description: 'Fang M, Hu L, Chen D, Guo Y, Liu J, Lan C, Gong J*, Wang B*. Exposome in human health: Utopia or wonderland? The Innovation. 2021, 2(4): 100172.'
      },{
        order: 3,
        link: 'https://ehp.niehs.nih.gov/doi/10.1289/EHP11305',
        description: 'Zhao F, Li L, Lin P, Chen Y, Xing S, Du H, Wang Z, Yang J, Huan T, Long C, Zhang L, Wang B*, Fang M*. HExpPredict: In Vivo Exposure Prediction of Human Blood Exposome using A Random Forest Model and Its Application in Chemical Risk Prioritization. Environ Health Perspect. 2023, 131(3):37009.'
      },{
        order: 4,
        link: 'https://www.sciencedirect.com/science/article/pii/S0304389423001759',
        description: 'Yang J, Zhao F, Zheng J, Wang Y, Fei X, Xiao Y, et al. 2023. An automated toxicity based prioritization framework for fast chemical characterization in non-targeted analysis. J Hazard Mater 448:130893.'
      },{
        order: 5,
        link: 'https://ehp.niehs.nih.gov/doi/10.1289/EHP7722',
        description: 'Zhao F, Li L, Chen Y, Huang Y, Keerthisinghe TP, Chow A, et al. 2021. Risk-based chemical ranking and generating a prioritized human exposome database. Environ Health Perspect 129:47014.'
      },{
        order: 6,
        link: 'https://www.sciencedirect.com/science/article/pii/S0003267019314369',
        description: 'Yang JJ, Han Y, Mah CH, Wanjaya E, Peng B, Xu TF, et al. 2020. Streamlined MRM method transfer between instruments assisted with HRMS matching and retention-time prediction. Anal Chim Acta 1100:88-96.'
      },{
        order: 7,
        link: 'https://pubs.acs.org/doi/10.1021/acs.estlett.4c00393',
        description: 'Nian M, Braun G, Escher B, Fang M*. Toxicological Study of Human Exposure to Mixtures of Chemicals: Challenges and Approaches. Environmental Science & Technology Letters, 2024,11,773-782'
      }],
      ExposomeXPlatformPublications: [{
        order: 1,
        link: 'https://pubs.acs.org/doi/10.1021/acs.estlett.2c00964',
        description: 'Wang B, Pang Y, Li K, Jiang J, Zhu Y, Li Z, Pan B, Zhang L, Zhang Y, Ye R, Li Z*. First evidence on the adverse effect of maternal germanium exposure on fetal neural tube defects, Environ Sci Technol Lett. 2023, 10: 192–197.'
      },{
        order: 2,
        link: 'https://pubs.acs.org/doi/10.1021/acs.estlett.3c00085',
        description: 'Feng Y, Su S, Lin W, Ren M, Gao N, Pan B, Zhang L, Jin L, Zhang Y, Li Z, Ye R, Ren A, Wang B*. Using Machine Learning to Expedite the Screening of Environmental Factors Associated with the Risk of Spontaneous Preterm Birth: From Exposure Mixtures to Key Molecular Events, Environ Sci Technol Lett, 2023, 10, 11, 1036–1044'
      },{
        order: 3,
        link: 'https://www.sciencedirect.com/science/article/pii/S0269749124003932?via%3Dihub',
        description: 'Ren M, Wu T, Yang S, Gao N, Lan C, Zhang H, Lin W, Su S, Yan L, Zhuang L, Lu Q, Xu J, Han B, Bai Z, Meng F, Chen Y, Pan B, Wang B*, Lu X, Fang M. Ascertaining sensitive exposure biomarkers of various metal(loid)s to embryo implantation. Environ Pollut. 2024 Mar 8;347:123679.'
      },{
        order: 4,
        link: 'https://linkinghub.elsevier.com/retrieve/pii/S0160-4120(24)00148-X',
        description: 'Liu X, Na J, Liu X, Jia X, Ren M, Chen J, Han B, Xu J*, Li N*, Li Z, Wang B. Co-exposure to phthalates and polycyclic aromatic hydrocarbons and the risk of gestational hypertension in Chinese women. Environ Int. 2024 Mar 6;185:108562.'
      },{
        order: 5,
        link: 'https://pubs.acs.org/doi/10.1021/acs.est.3c10904',
        description: 'Zhang G, Lin W, Gao N, Lan C, Ren M, Yan L, Pan B, Xu J, Han B, Hu L, Chen Y, Wu Y, Zhuang L*, Qun Lu*, Bin Wang*, Fang M. Using Machine Learning to Construct the Blood−Follicle Distribution Models of Various Trace Elements and Explore the Transport-Related Pathways with Multiomics Data. Environmental Science & Technology. 2024, 58, 18, 7743–7757.'
      },{
        order: 6,
        link: '',
        description: 'Su S, Ren M, Feng Y, Lan C, Yan L, Lu Q, Zhuang L, Fang M, Bao H*, Wang B*, Pan B. Associations between Metallomic Exposure and Risk of Polycystic Ovary Syndrome Mediated by Anti-Müllerian Hormone among Women Undergoing In Vitro Fertilization and Embryo Transfer. Biomed Environ Sci, 2024 Oct 20;37(10):1107-1116.'
      },{
        order: 7,
        link:'https://pubs.acs.org/doi/10.1021/acs.est.4c09711',
        description: 'Zhang W, Deng S, Zhang X, Huang C, Liu C*, Jiang G. Network-Based Identification of Key Toxic Compounds in Airborne Chemical Exposome. Environ Sci Technol. 2025 Jan 28;59(3):1712-1723. '
      },{
        order: 8,
        link:'https://pubs.acs.org/doi/10.1021/acs.est.5c05389',
        description: 'Mengyuan Ren, Tianxiang Wu, Han Zhang, Shuo Yang, Lu Zhao, Lili Zhuang, Qun Lu, Xikun Han, Bo Pan, Tiantian Li, Jingchuan Xue, Yuanchen Chen, Michael S. Bloom, Mingliang Fang, Bin Wang*. Using Environmental Mixture Exposure-Triggered Biological Knowledge-Driven Machine Learning to Predict Early Pregnancy Loss. Environmental Science & Technology 2025, 59 (37) , 19691-19704.'
      }]
    };
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.page {
  text-align: left;
  padding: 20px 80px;
}
.content {
  word-break: break-word;
  overflow: hidden;
  text-align: left;
  line-height: $line-height-x-large;
  font-size: $webpage-base-font-size;
}
.title {
  font-size: $webpage-large-font-size;
  font-weight: 600;
  margin: 0.8em 0 0.4em;
}
.link {
  color: $black;
  text-decoration: none;
}
@media screen and (max-width: 600px) {
  .page {
    text-align: left;
    padding: 10px 20px;
  }
}
</style>
